import { TopicApi, topicsApi } from "api/topics/topicsApi";
import { useEffect, useState } from "react";

export const useTopic = (topicId: number) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [data, setData] = useState<TopicApi | null>(null);

  useEffect(() => {
    const fetchTopic = async () => {
      if (!topicId) {
        console.error("Topic id not found.");
        setLoading(false);
        return;
      }
      const res = await topicsApi.fetchById(topicId);
      try {
        setData(res.data);
      } catch (error) {
        // Handle error appropriately, perhaps with another state variable
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchTopic();
  }, [topicId]);

  return { loading, data };
};
